import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { LocalizedLink } from '@/components/LocalizedLink'

interface ProductCardProps {
  title: string
  description: string
  image: string
  imageAlt: string
  href: string
  index?: number
}

export function ProductCard({
  title,
  description,
  image,
  imageAlt,
  href,
  index = 0,
}: ProductCardProps) {
  const { t } = useTranslation()

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.4 }}
    >
      <LocalizedLink
        to={href}
        className="group relative flex flex-col h-full rounded-xl overflow-hidden transition-all"
        style={{
          backgroundColor: '#ffffff',
          border: '1px solid #e2e8f0',
        }}
      >
        {/* Image */}
        <div className="aspect-[4/3] overflow-hidden" style={{ backgroundColor: '#f8fafc' }}>
          <img
            src={image}
            alt={imageAlt}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform"
            loading="lazy"
          />
        </div>

        {/* Content */}
        <div className="p-5 flex flex-col flex-1">
          <h3
            className="font-semibold text-lg transition-colors line-clamp-2"
            style={{ color: '#0f172a' }}
          >
            {title}
          </h3>
          <p className="mt-2 text-sm line-clamp-3 flex-1" style={{ color: '#64748b' }}>
            {description}
          </p>
          <div className="mt-4 flex items-center text-sm font-medium" style={{ color: '#00a3cc' }}>
            {t('buttons.learnMore', 'Learn More')}
            <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </div>
        </div>
      </LocalizedLink>
    </motion.div>
  )
}
